import React, { useCallback, useContext, useEffect, useState } from "react";
import RtlProvider from "../../../Components/RtlProvider";
import { ContextNotification, severitys } from "../../../App";
import { Box, Button, Container, FormControl, Grid2, InputLabel, MenuItem, Modal, Select, TextField, Typography, useTheme } from "@mui/material";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import helper from "../../../helper";
import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";
import { NavLink } from "react-router-dom";
import { MdAdd, MdExpandLess, MdExpandMore, MdList, MdOutlineListAlt, MdOutlineSearch, MdReviews } from "react-icons/md";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian from "react-date-object/calendars/gregorian"
import gregorian_en from "react-date-object/locales/gregorian_en"
import CustomDateInput from "../../../Components/CustomDateInput";
import enumMapper from "../../../enumMapper";
import moment from 'jalali-moment'

import { useMemo } from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';

import guestGroupApi from "../../../api/guestGroupApi";
import GroupInfo from "./GroupInfo";

const GuestRequestList = () => {

    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const { open, setOpen } = useContext(ContextNotification);

    //data and fetching state
    const [data, setData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    //table state
    const [columnFilters, setColumnFilters] = useState(
        [],
    );
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    const [refresh, setRefresh] = useState(false);
    const [loadingRows, setLoadingRows] = useState(false);



    const [rowDetails, setRowDetails] = useState({}); // key = row.id, value = API data
    const [loadingDetails, setLoadingDetails] = useState({}); // loading state per row


    const columns = useMemo(
        () => [
            {
                accessorKey: 'recordNumber',
                header: 'ردیف',
                size: 100,
                enableSorting: false,
            },

            {
                accessorKey: 'data.parentInfo.name',
                id: 'firstName',
                header: 'نام',
                size: 150,

            },
            {
                accessorKey: 'data.parentInfo.family', //normal accessorKey
                id: 'family',
                header: 'نام خانوادگی',
                size: 200,

            },
            {
                accessorKey: 'data.parentInfo.passNo', //normal accessorKey
                id: 'passNo',
                header: 'شماره گذرنامه',
                size: 150,

            },
            {
                accessorKey: 'data.startTrip', //normal accessorKey
                id: 'startTrip',
                header: 'از',
                size: 150,
                Cell: ({ cell, row }) => (
                    row.original.data?.persian_StartTrip
                ),

            },
            {
                accessorKey: 'data.endTrip', //normal accessorKey
                id: 'endTrip',
                header: 'تا',
                size: 150,
                Cell: ({ cell, row }) => (
                    row.original.data?.persian_EndTrip
                ),

            },



        ],
        [],
    );
    const table = useMaterialReactTable({
        columns,
        data,
        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,
        rowCount,
        enableExpandAll: false,
        enableRowActions: true,
        positionActionsColumn: 'last',

        muiToolbarAlertBannerProps: isError
            ? { color: 'error', children: 'Error loading data' }
            : undefined,

        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,

        state: {
            columnFilters,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
        },

        localization: {
            sortByColumnAsc: '',
            sortByColumnDesc: '',
            sortedByColumnAsc: '',
            sortedByColumnDesc: '',
        },

        enableFilters: false,

        // Table Head styling (dark gray header, white text/icons)
        muiTableHeadCellProps: {
            sx: {
                backgroundColor: '#4d4d4d',
                color: '#fff',
                fontWeight: 'bold',
                border: '1px solid #bfbfbf', // keeps header cell borders
                padding: '8px 12px',
                textAlign: 'left',
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': { color: '#e6e6e6' },
                    '&.Mui-active': { color: '#fff' },
                    
                },
                '& .MuiTableSortLabel-icon': {
                    color: '#fff !important',
                    '&:hover': { color: '#e6e6e6' },
                    '&.Mui-active': { color: '#fff' },
                    
                },
            },
        },

        // Actions & Expand column styling
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: '',
                size: 120,
                muiTableHeadCellProps: {
                    sx: {
                        color: '#fff',
                        backgroundColor: '#4d4d4d',
                        border: '1px solid #bfbfbf',
                        textAlign: 'center',
                    },
                },
                muiTableBodyCellProps: {
                    sx: {
                        color: '#000',
                        '& .MuiIconButton-root': {
                            color: '#000 !important',
                        },
                        '&:hover .MuiIconButton-root': {
                            color: '#333 !important',
                        },
                    },
                },
            },
            'mrt-row-expand': {
                header: '',
                muiTableHeadCellProps: {
                    sx: {
                        color: '#fff',
                        backgroundColor: '#4d4d4d',
                        border: '1px solid #bfbfbf',
                        textAlign: 'center',
                    },
                },
            },
        },

        // Table Body Cell styling (keep borders)
        muiTableBodyCellProps: {
            sx: {
                border: '1px solid #bfbfbf', // cell borders only
                padding: '8px 12px',
                color: '#000',
            },
        },

        // Table Body Row styling (hover color under cell borders)
        muiTableBodyRowProps: ({ row }) => ({
            sx: {
                backgroundColor: row.index % 2 === 0 ? '#ffffff' : '#f2f2f2', // alternating rows
                '&:hover': {
                    backgroundColor: '#e6e6e6', // hover under cell borders
                },
            },
        }),

        // Remove outer table body border
        muiTableBodyProps: {
            sx: {
                border: 'none', // flat look, no outer border
                borderCollapse: 'collapse',
            },
        },

        muiExpandButtonProps: ({ row, table }) => ({
            children: row.getIsExpanded() ? <MdExpandMore /> : <MdExpandLess />,
            onClick: async () => {
                // toggle expansion
                // table.setExpanded({ [row.id]: !row.getIsExpanded() });
                table.setExpanded({ [row.id.toString()]: !row.getIsExpanded() });

                // fetch details only if not already loaded
                if (!rowDetails[row.id]) {
                    setLoadingDetails(prev => ({ ...prev, [row.id]: true }));
                    try {
                        const res = await guestGroupApi.GetGroupInfoById(row.original.data.id); // <-- your API call
                        setRowDetails(prev => ({ ...prev, [row.id]: res.data }));
                    } catch (err) {
                        console.error(err);
                    } finally {
                        setLoadingDetails(prev => ({ ...prev, [row.id]: false }));
                    }
                }
            },
            sx: {
                transform: row.getIsExpanded() ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s',
                color: '#4d4d4d',
            },
        }),


        // Row Actions styling (outlined gray buttons with black borders)
        renderRowActions: () => (
            <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                {/* <Button
        variant="outlined"
        sx={{
          backgroundColor: '#f2f2f2',
          color: '#000',
          border: '1px solid #000',
          '&:hover': {
            backgroundColor: '#e6e6e6',
            border: '1px solid #000',
          },
        }}
      >
        درخواست ها
      </Button> */}
            </Box>
        ),

        renderDetailPanel: ({ row }) => {
            const detail = rowDetails[row.id];
            const loading = loadingDetails[row.id];

            if (loading) return <Typography sx={{ p: 2 }}>در حال بارگذاری...</Typography>;
            // Always return a Box, even if detail is null
            return detail ? (
                <Box sx={{ p: 2, backgroundColor: '#f9f9f9' }}>




                    <GroupInfo data={detail.data} refreshGrid2={RefreshGrid}/>






                </Box>
            ) : (
                <Box sx={{ p: 2 }}>اطلاعات موجود نیست</Box>
            );
        }


    });


    const schema = yup.object().shape({

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
        defaultValues: {
            firstName: null,
            lastName: null,
            operation: enumMapper.Operation.Operation1404.toString()
        },
        resolver: yupResolver(schema),
    });

    const getfilteritems = () => {
        const name = watch("name") || null;
        const family = watch("family") || null;
        const passNo = watch("passNo") || null;
        const filterItems = [];

        //startTrip
        let startTripGregorian = null;
        if (watch("startTrip")) {
            let startTrip = new DateObject({
                date: watch("startTrip"),
                calendar: persian,
                locale: persian_fa
            });

            var startTripStr = startTrip.year + '/' + startTrip.month.number + '/' + startTrip.day;
            startTripGregorian = moment.from(startTripStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }

        //endTrip
        let endTripGregorian = null;
        if (watch("endTrip")) {
            let endTrip = new DateObject({
                date: watch("endTrip"),
                calendar: persian,
                locale: persian_fa
            });

            var endTripStr = endTrip.year + '/' + endTrip.month.number + '/' + endTrip.day;
            endTripGregorian = moment.from(endTripStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }

        const filterData = {
            "name":name,
            "family":family,
            "passNo": passNo,
            "startTrip": startTripGregorian,
            "endTrip": endTripGregorian,
            "filters": filterItems,
            "orderBy": sorting.length > 0 ? sorting[0].id : 'StartTrip',
            "orderDescending": sorting.length > 0 ? sorting[0].desc : true,
            "pageSize": pagination.pageSize,
            "pageNumber": pagination.pageIndex + 1
        }
        return filterData;
    }

    const onSubmit = (data) => {
        const filterData = getfilteritems();
        GetData(filterData);
    };

    useEffect(() => {

    }, [])

    useEffect(() => {
        const paginationModel = getfilteritems();
        GetData(paginationModel);
    }, [refresh,
        columnFilters, //re-fetch when column filters change
        globalFilter, //re-fetch when global filter changes
        pagination.pageIndex, //re-fetch when page index changes
        pagination.pageSize, //re-fetch when page size changes
        sorting, //re-fetch when sorting changes
    ]);

    const GetData = (filterData) => {
        if (!data.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }
        guestGroupApi.FilterGroup(filterData)
            .then((res) => {
                setData(res.data.data.items);
                const rowcnt = res.data.data.totalCount;
                setRowCount(rowcnt);
            })
            .catch((error) => {
                console.log(error);
                setIsError(true);
            }).finally(() => {
                setIsError(false);
                setIsLoading(false);
                setIsRefetching(false);
            });
    }

    const RefreshGrid = (result) => {
        if (result) {
            setRefresh(old => !old);

        }
    }

    return (
        <Container maxWidth={false} sx={{ py: 3 }}>

            <Typography
                variant="h5"
                sx={{
                    fontWeight: "bold",
                    mb: 3,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <MdOutlineListAlt /> لیست درخواست ها
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 container spacing={2}>
                    <Grid2 xs={12} sm={6} md={2} lg={1} xl={1.5}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="نام"
                            {...register("name")}
                        />
                    </Grid2>
                    <Grid2 xs={12} sm={6} md={2} lg={1} xl={1.5}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="نام خانوادگی"
                            {...register("family")}
                        />
                    </Grid2>

                    {/* Passport Number */}
                    <Grid2 xs={12} sm={6} md={2} lg={1} xl={1.5}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="شماره گذرنامه"
                            {...register("passNo")}
                        />
                    </Grid2>

                    {/* Start Trip Date */}
                    <Grid2 xs={12} sm={6} md={4} lg={1.5} xl={1.5}>
                        <Controller
                            name="startTrip"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                                <DatePicker
                                    value={value || ""}
                                    onChange={(date) => onChange(date?.isValid ? date : "")}
                                    format="YYYY/MM/DD"
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    render={<CustomDateInput label="از تاریخ" />}
                                />
                            )}
                        />
                    </Grid2>

                    {/* End Trip Date */}
                    <Grid2 xs={12} sm={6} md={4} lg={1.5} xl={1.5}>
                        <Controller
                            name="endTrip"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                                <DatePicker
                                    value={value || ""}
                                    onChange={(date) => onChange(date?.isValid ? date : "")}
                                    format="YYYY/MM/DD"
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    render={<CustomDateInput label="تا تاریخ" />}
                                />
                            )}
                        />
                    </Grid2>

                    {/* Search Button */}
                    <Grid2 xs={12} sm={12} md={3} lg={2} xl={1.4} sx={{ textAlign: "left" }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<MdOutlineSearch />}
                        >
                            جستجو
                        </Button>
                    </Grid2>
                </Grid2>
            </form>

            {/* Result Count */}
            <Box sx={{ textAlign: "right", pt: 2, pb: 2 }}>
                تعداد نتایج: {rowCount}
            </Box>

            {/* Table */}
            <MaterialReactTable table={table} />
        </Container>

    );
}

export default GuestRequestList;
